import React from 'react';

function Features() {
  return (
    <section id="features" className="features-section">
      <div className="container">
        <h2>The Smart Garden You've Always Wanted</h2>
        <div className="features-grid">
          {/* Feature 1: My Homestead */}
          <div className="feature-card">
            <img src="/images/homestead_screen.png" alt="My Homestead feature illustration" className="feature-image"/>
            <h3>My Homestead</h3>
            <p>Your digital dashboard. Manage gardens, monitor planting schedules, automatic ripeness detection, and more.</p>
          </div>

          {/* Feature 2: Homestead AI */}
          <div className="feature-card">
            <img src="/images/homestead_ai.png" alt="Homestead AI feature illustration" className="feature-image"/>
            <h3>Homestead AI</h3>
            <p>Your personal homesteading guru. Ask questions, get advice on planting times, pest control, animal care, and more from our helpful AI assistant.</p>
          </div>

          {/* Feature 3: Farmers Market */}
          <div className="feature-card">
            <img src="/images/farmers_market.jpeg" alt="Farmers Market feature illustration" className="feature-image"/>
            <h3>Farmers Market</h3>
            <p>Use the Homesteadr Agent to list your produce for free, trade, or sale in a local, community-focused marketplace.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
